import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=2bb45dde"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BookBrochureware: require('/home/runner/work/platform/platform/packages/client/src/components/elements/book/book-brochureware/BookBrochureware.vue').default})
